import React from 'react';
import { Helmet } from 'react-helmet';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import img1 from '../../../Gemco-Website-Images/Homepage/HP-01-hero-dubai-skyline.jpg';
import img2 from '../../../Gemco-Website-Images/Homepage/Museum-of-the-Future-Dubai.jpg';
import img3 from '../../../Gemco-Website-Images/Homepage/HP-16-dubai_airport.jpg';

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import './Home.css';

const Home = () => {
  return (
    <>
    <Helmet>
        <title>Home | GEMCO</title>
        <meta name="description" content="GEMCO delivers specialist MEP supply and installation services across the UAE, trusted on iconic projects for over 25 years including Wynn Al Marjan Island and the Museum of the Future." />
        <meta name="keywords" content="GEMCO UAE, specialist MEP contractor, MEP supply and installation, iconic UAE projects, Museum of the Future MEP, Wynn Al Marjan Island MEP, Dubai MEP company, commercial MEP services, HVAC electrical plumbing UAE, trusted MEP contractor UAE, large scale MEP projects." />
    </Helmet>
    <div className="wp_image-container">
       
     <div className="wp_hero_section" alt="dubai skyline">
       <div className="hero-slider">

  <Swiper
      modules={[Pagination, Autoplay]}
      navigation
      pagination={{ clickable: true }}
      autoplay={{ delay: 5000 }}
      loop
    >
    <SwiperSlide>
      <img className='slide_image' fetchpriority="high" decoding="async" src={img1} alt="" />
    </SwiperSlide>

    <SwiperSlide>
      <img className='slide_image' fetchpriority="high" decoding="async" src={img2} alt="" />
    </SwiperSlide>

    <SwiperSlide>
      <img className='slide_image' fetchpriority="high" decoding="async" src={img3} alt="" />
    </SwiperSlide>
  </Swiper>

  {/* Content shown on all slides */}
  <div className="hero-content">
    <div className="container">
      <div className="inside-hero-content">
      <h1>
      More than 25 years of trust on UAE's iconic projects
    </h1>
    

    {/* <h2>
      From Wynn Al Marjan Island to the Museum of the Future — GEMCO delivers
      precision MEP works for the projects that demand the best.
    </h2> */}

    <h2>Interested MEP supply and installation</h2>

    <div className="wp_btn-container">
      <a href="/our-projects" className="btn1">
        View Our Project
      </a>

      <a href="/contact-us" className="btn2">
        Contact Us
      </a>
    </div>
    </div>
  </div>
</div>
</div>
     </div>

    </div>
    </>
  )
}

export default Home